import axios from 'axios';
import types from '../../types';
/* eslint-disable */

export default {
  [types.GET_INTERNAL_NOTIFICATIONS]: async (context, payload) => {
    try {
      const page = payload?.page || 1
      await axios.get(`notification-action/get-user-notifications?page=${page}`).then((res) => {
        if(page === 1){
          context.commit('CLEAR_INTERNAL_NOTIFICATIONS');
          context.commit('STORE_INTERNAL_NOTIFICATIONS', res.data.data);
        } else {
          context.commit('STORE_INTERNAL_NOTIFICATIONS', res.data.data);
        }});
    } catch (err) {
      console.error(err);
    }
  },
  [types.MARK_INTERNAL_NOTIFICATIONS_SEEN]: async (context, payload) => {
    try {
      context.commit(types.RESET_NOTIFICATION_COUNT);
      await axios.post(`notification-action/mark-seen`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_INTERNAL_NOTIFICATIONS]: ({ commit }, payload) => {
    commit('STORE_INTERNAL_NOTIFICATIONS', payload);
  },
  [types.CLEAR_INTERNAL_NOTIFICATIONS]: (context) => {
    context.commit('CLEAR_INTERNAL_NOTIFICATIONS');
  },
};
